import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { IndexDaily, previewDaily, updateRecordClassTaught, FormEdit, fetchLogo, GetMatter } from "../../Api";

import LoadingSpinner from "../../components/Loading";
import {
  Container,
  AttendanceContainer,
  ContInfo,
  CtnrBtt,
  Button,
  ContTable,
  Table,
  TableHeader,
  TableBody,
  ToGoBack,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  Butons,
  ButtonPrint,
  UpperButons,
  Btt02,
  ButtonGroup,
  //BottomButons,
  LessonsContainer,
  ContainerTable,
  Span,
  TableRow,
  DateCell,
  DescriptionCell,
  InfoText,
  HiddenOnPrint,
  StudentSection,
  PrintStyleLessons,
  EditContainer,
  ErrorMessage,
  ButtonEdit,
  AssessmentsContainer,
  GradesTableContainer,
  GradesTable,
  GradesTableHeader,
  GradesTableBody,
  LegendBox,
  ConceptsTableContainer,
  ConceptsTable,
  ConceptsTableHeader,
  ConceptsTableBody,
  IndividualContainerDivs,
  IndividualPrintStyle,
  IndividualStudentSection,
  IndividualContainerTable,
  IndividualTableRow,
  IndividualDescriptionCell,
  ContLogo,
  Preview,
  HeaderWrapper
  //ToggleButton,
} from "./style";

import ReactQuill from 'react-quill';
import { NotaComRec, LegendaNotas, useRecuperacoes } from '../../components/Recuperacao';

// faixa "PRÉVIA" (estilo inline para sair também nas impressões que copiam o HTML)
const FAIXA_PREVIA_HTML =
  '<div style="border:2px solid #b45309;background:#fff4e5;color:#7c2d12;font-weight:800;font-size:14px;' +
  'text-align:center;padding:6px 10px;margin:0 0 8px;border-radius:6px;-webkit-print-color-adjust:exact;print-color-adjust:exact;">' +
  'PRÉVIA — diário não fechado</div>';

export default function Daily() {
  const { idClass, idBimonthly, bimonthly } = useParams();
  // ?previa=1 → diário ainda aberto: reúne tudo o que já está gravado e mostra marcado como PRÉVIA
  const location = useLocation();
  const previa = new URLSearchParams(location.search).get('previa') === '1';
  const comMarca = (html) => (previa ? FAIXA_PREVIA_HTML + html : html);
  // recuperações lançadas na turma (aparecem como 'Rec=' na nota do período)
  const { recFinal } = useRecuperacoes({ id_class: idClass });
  const [data, setData] = useState(null);
  const [matters, setMatter] = useState([]);
  const [activeComponent, setActiveComponent] = useState(() => {
    return sessionStorage.getItem('activeComponent') || 'attendanceList';
  });
  const [assessmentFormat, setassessmentFormat] = useState('');
  //const [selectedTab, setSelectedTab] = useState("attendance"); // "attendance", "lessons", "grades"...

  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const [expandedRows, setExpandedRows] = useState([]);
  const [printing, /*setPrinting*/] = useState(false);

  //const [recordClassTaught, setRecordClassTaught] = useState([]);
  const [positionAtSchool, setPositionAtSchool] = useState(null);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingId, setEditingId] = useState('');
  const [editedDescription, setEditedDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [expandedSections, setExpandedSections] = useState({
    regent: false,
    edfisica: false,
  });

  const [expandedAssessments, setExpandedAssessments] = useState([]);

  const [selectedStudentGrades, setSelectedStudentGrades] = useState(null);

  const [selectedStudentConcept, setSelectedStudentConcept] = useState(null);

  const [logoUrl, setLogoUrl] = useState('');

  const [loading, setLoading] = useState(true);

  const [assessmentRegime, setAssessmentRegime] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true);
      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

      // matérias da escola na ordem do usuário (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar matérias:', e);
      }
      const position = localStorage.getItem('position_at_school');
      setPositionAtSchool(position);
      const $assessmentFormat = sessionStorage.getItem('assessmentFormat')
      setassessmentFormat($assessmentFormat)
      //setAssessmentRegime(sessionStorage.getItem('assessmentRegime'))

      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }

      if (previa) {
        const CAMPO = { "1º BIMESTRE": "id_iStQuarter", "2º BIMESTRE": "id_iiNdQuarter", "3º BIMESTRE": "id_iiiRdQuarter", "4º BIMESTRE": "id_ivThQuarter" }[bimonthly];
        try {
          const res = await previewDaily({ idClass, [CAMPO]: idBimonthly });
          const daily = res?.data?.dailies?.[0] || null;
          setAssessmentRegime(daily?.[CAMPO]?.assessmentRegime);
          setData(daily);
        } catch (e) {
          alert(e?.response?.data?.msg || 'Não foi possível montar a prévia do diário.');
          setData(null);
        }
        setLoading(false);
        return;
      }

      if (bimonthly === "1º BIMESTRE") {
        const res = await IndexDaily({
          idClass,
          id_iStQuarter: idBimonthly
        });
        const daily = res.data.dailies[0];

        // pega o regime dentro do bimestre populado
        const regime = daily?.id_iStQuarter?.assessmentRegime;
        console.log("daily", daily)
        setAssessmentRegime(regime);
        setData(daily);
        setLoading(false);
      }
      if (bimonthly === "2º BIMESTRE") {
        const res = await IndexDaily({
          idClass,
          id_iiNdQuarter: idBimonthly
        });
        const daily = res.data.dailies[0];

        // pega o regime dentro do bimestre populado
        const regime = daily?.id_iiNdQuarter?.assessmentRegime;

        setAssessmentRegime(regime);
        setData(daily);
        setLoading(false);
      }
      if (bimonthly === "3º BIMESTRE") {
        const res = await IndexDaily({
          idClass,
          id_iiiRdQuarter: idBimonthly
        });
        const daily = res.data.dailies[0];

        // pega o regime dentro do bimestre populado
        const regime = daily?.id_iiiRdQuarter?.assessmentRegime;

        setAssessmentRegime(regime);
        setData(daily);
        setLoading(false);
      }
      if (bimonthly === "4º BIMESTRE") {
        const res = await IndexDaily({
          idClass,
          id_ivThQuarter: idBimonthly
        });
        const daily = res.data.dailies[0];

        // pega o regime dentro do bimestre populado
        const regime = daily?.id_ivThQuarter?.assessmentRegime;

        setAssessmentRegime(regime);
        setData(daily);
        setLoading(false);
      }

    })();
  }, [bimonthly, idClass, idBimonthly, previa]);

  console.log("data", data)
  function handleRowClick(studentId) {
    if (selectedStudentId === studentId) {
      setSelectedStudentId(null); // desmarca se clicar na mesma linha
    } else {
      setSelectedStudentId(studentId); // seleciona nova linha
    }
  }

  const normalizeString = (str) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s]/gi, "").toUpperCase();

  // formata data de nascimento "2019-11-19" -> "19/11/2019"
  const formatBirthDate = (dob) => {
    if (!dob) return "";
    const [y, m, d] = String(dob).split("T")[0].split("-");
    return d && m && y ? `${d}/${m}/${y}` : "";
  };
  const BirthDate = ({ cpf, dob }) =>
    (cpf || dob) ? (
      <div style={{ fontSize: "11px", fontWeight: "normal", color: "#666", lineHeight: 1.1 }}>
        {cpf && <div>CPF: {cpf}</div>}
        {dob && <div>Nasc: {formatBirthDate(dob)}</div>}
      </div>
    ) : null;

  /*const formatDisplayDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    return `${day}/${month}`;
  };*/

  /*const uniqueDates = data
    ? [...new Set(data.attendance.map((att) => formatDisplayDate(att.date)))].sort((a, b) => {
      const [d1, m1] = a.split("/").map(Number);
      const [d2, m2] = b.split("/").map(Number);
      return m1 === m2 ? d1 - d2 : m1 - m2;
    })
    : [];*/

  const formatKey = (date) => {
    if (!date) return "";

    // Pega só a parte YYYY-MM-DD da string ISO
    // Isso ignora completamente hora e fuso horário
    return date.split("T")[0];
  };

  const uniqueDates = data?.attendance
    ? [...new Set(data.attendance.map((a) => formatKey(a.date)))].sort()
    : [];

  const groupedByMonth = uniqueDates.reduce((acc, dateStr) => {
    const month = Number(dateStr.split("-")[1]) - 1; // pega mês da string YYYY-MM-DD
    if (!acc[month]) acc[month] = [];
    acc[month].push(dateStr);
    return acc;
  }, {});

  const allDatesFlat = Object.entries(groupedByMonth).flatMap(
    ([month, dates], monthIndex) =>
      dates.map((dateStr) => ({
        date: dateStr,
        isAlt: monthIndex % 2 === 0,
      }))
  );

  const getMonthName = (month) => {
    const months = [
      "JANEIRO", "FEVEREIRO", "MARÇO", "ABRIL",
      "MAIO", "JUNHO", "JULHO", "AGOSTO",
      "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"
    ];
    return months[month];
  };

  // Geral
  const getAttendanceStatus = (studentId, dateKey) => {
    const match = data.attendance.find(
      (a) => a.id_student === studentId && formatKey(a.date) === dateKey
    );

    if (!match) return <td className="status-cell">-</td>;

    return (
      <td
        className={`status-cell ${match.status === "P"
          ? "presence"
          : match.status === "FJ"
            ? "justifiedAbsence"
            : "absence"
          }`}
      >
        {match.status}
      </td>
    );
  };
  const calculateTotals = (studentId) => {
    const filtered = data.attendance.filter((a) => a.id_student === studentId);
    return {
      totalPresence: filtered.filter((a) => a.status === "P").length,
      totalAbsence: filtered.filter((a) => a.status === "F").length,
      totalJustified: filtered.filter((a) => a.status === "FJ").length
    };
  };

  // 🔹 Datas únicas (Ed. Física)
  const uniqueDatesPhysical = data?.attendancePhysicalEducationTeacher
    ? [...new Set(data.attendancePhysicalEducationTeacher.map((a) => formatKey(a.date)))].sort()
    : [];

  const groupedByMonthPhysical = uniqueDatesPhysical.reduce((acc, dateStr) => {
    const month = Number(dateStr.split("-")[1]) - 1;
    if (!acc[month]) acc[month] = [];
    acc[month].push(dateStr);
    return acc;
  }, {});

  const allDatesFlatPhysical = Object.entries(groupedByMonthPhysical).flatMap(
    ([month, dates], monthIndex) =>
      dates.map((dateStr) => ({
        date: dateStr,
        isAlt: monthIndex % 2 === 0,
      }))
  );

  // 🔹 Status da chamada (Ed. Física)
  const getAttendanceStatusPhysical = (studentId, dateKey) => {
    const match = data.attendancePhysicalEducationTeacher?.find(
      (a) => a.id_student === studentId && formatKey(a.date) === dateKey
    );

    if (!match) return <td className="status-cell">-</td>;

    return (
      <td
        className={`status-cell ${match.status === "P"
          ? "presence"
          : match.status === "FJ"
            ? "justifiedAbsence"
            : "absence"
          }`}
      >
        {match.status}
      </td>
    );
  };

  // 🔹 Totais (Ed. Física)
  const calculateTotalsPhysical = (studentId) => {
    const filtered = (data?.attendancePhysicalEducationTeacher || []).filter(
      (a) => a.id_student === studentId
    );
    return {
      totalPresence: filtered.filter((a) => a.status === "P").length,
      totalAbsence: filtered.filter((a) => a.status === "F").length,
      totalJustified: filtered.filter((a) => a.status === "FJ").length,
    };
  };

  const handleComponentChange = (component) => {
    if (activeComponent !== component) {
      sessionStorage.setItem('activeComponent', component);
      setActiveComponent(component); // Agora apenas atualiza o estado
    }
  };

  const toggleRowExpansion = (index) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  // função para alternar abertura
  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getDescriptionPreview = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = div.textContent || div.innerText || '';
    return text.length > 250 ? text.substring(0, 250) + '...' : text;
  };

  const isActive = (component) => activeComponent === component;

  const handlePrintAttendance = () => {
    const printContent = document.getElementById("printable-content-attendance");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
          <html>
            <head>
              <title>Impressão</title>
              <style>
              .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { 
                  text-align: center;
                  border: 1px solid #8c8c8c;
                  font-size: 12px;
                  padding: 1px; 
                }
                  tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                    
                  }
                  .name-cell {
                      text-align: start;
                  }
                      /* 🔥 FORÇA IMPRESSÃO DE CORES */
                  * {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }

                  /* 🔥 CORES DOS MESES */
                  .month-alt {
                    background-color: #d0d0d0 !important;
                  }

                  .month-normal {
                    background-color: #ffffff !important;
                  }

                  /* 🔥 (EXTRA) separação mesmo sem cor */
                  .month-alt,
                  .month-normal {
                    border-right: 1px solid #666;
                  }
                @page {
                  size: A4 landscape; /* Define o formato da página como paisagem */
                  margin: 0;
                }  
                ContTable {
                  overflow-x: hidden; /* Permite rolagem horizontal */
                  width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                  margin-left: auto; /* Centraliza horizontalmente */
                  margin-right: auto; /* Centraliza horizontalmente */
                }
                  .printable-content-attendance {
                    visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                    font-size: 15px;
                    //transform: scale(1); /* Ajusta a escala da tabela */
                  }
                .data {
                  display: flex;
                  gap:15px;
                }
                  .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
                .info {
                  display: flex;
                  flex-direction: column;
                }
                  .info span {
                    
                    font-size: 15px;
                  }
                  .no-print {
                    display: none !important;
                  }
                     /* ✅ Classes de status */
                     td.presence { 
                      color: green;
                      font-weight: bold; 
                    }
                    td.absence { 
                      color: red;
                      font-weight: bold; 
                    }
                    td.justifiedAbsence { 
                      color: #6a0dad;
                      font-weight: bold; 
                    }

                    th.total-presence { color: green; }
                    th.total-absence { color: red; }
                    th.total-justifiedAbsence { color: #6a0dad; }
              </style>
            </head>
            <body>
              ${comMarca(printContent.innerHTML)} 
            </body>
          </html>
        `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintAttendancePhysicalEducation = () => {
    const printContent = document.getElementById("printable-content-attendancePhysicalEducation");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
          <html>
            <head>
              <title>Impressão</title>
              <style>
              .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { 
                  text-align: center;
                  border: 1px solid #8c8c8c;
                  font-size: 12px;
                  padding: 1px; 
                }
                  tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                    
                  }
                  .name-cell {
                      text-align: start;
                  }
                       /* 🔥 FORÇA IMPRESSÃO DE CORES */
                  * {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }

                  /* 🔥 CORES DOS MESES */
                  .month-alt {
                    background-color: #d0d0d0 !important;
                  }

                  .month-normal {
                    background-color: #ffffff !important;
                  }

                  /* 🔥 (EXTRA) separação mesmo sem cor */
                  .month-alt,
                  .month-normal {
                    border-right: 1px solid #666;
                  }
                @page {
                  size: A4 landscape; /* Define o formato da página como paisagem */
                  margin: 0;
                }  
                ContTable {
                  overflow-x: hidden; /* Permite rolagem horizontal */
                  width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                  margin-left: auto; /* Centraliza horizontalmente */
                  margin-right: auto; /* Centraliza horizontalmente */
                }
                  .printable-content-attendance {
                    visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                    font-size: 15px;
                    //transform: scale(1); /* Ajusta a escala da tabela */
                  }
                .data {
                  display: flex;
                  gap:15px;
                }
                  .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
                .info {
                  display: flex;
                  flex-direction: column;
                }
                  .info span {
                    
                    font-size: 15px;
                  }
                  .no-print {
                    display: none !important;
                  }
                      /* ✅ Classes de status */
                     td.presence { 
                      color: green;
                      font-weight: bold; 
                    }
                    td.absence { 
                      color: red;
                      font-weight: bold; 
                    }
                    td.justifiedAbsence { 
                      color: #6a0dad;
                      font-weight: bold; 
                    }

                    th.total-presence { color: green; }
                    th.total-absence { color: red; }
                    th.total-justifiedAbsence { color: #6a0dad; }
              </style>
            </head>
            <body>
              ${comMarca(printContent.innerHTML)} 
            </body>
          </html>
        `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  const handlePrintClasses = async () => {
    toggleSection('regent')
    setExpandedRows(data.id_recordClassTaught.map((_, index) => index));

    // Espera meio segundo para o React aplicar a expansão do DOM
    await sleep(500);

    const printContent = document.getElementById('print-area');
    if (!printContent) return;

    const originalContent = document.body.innerHTML;

    document.body.innerHTML = comMarca(printContent.innerHTML);
    window.print();
    document.body.innerHTML = originalContent;

    // Recarrega a página para restaurar estados e eventos React
    window.location.reload();
  };

  const handlePrintClassesEdFisica = async () => {
    toggleSection('edfisica')
    setExpandedRows(data.id_recordClassTaught.map((_, index) => index));

    // Espera meio segundo para o React aplicar a expansão do DOM
    await sleep(500);

    const printContent = document.getElementById('print-areaEdFisica');
    if (!printContent) return;

    const originalContent = document.body.innerHTML;

    document.body.innerHTML = comMarca(printContent.innerHTML);
    window.print();
    document.body.innerHTML = originalContent;

    // Recarrega a página para restaurar estados e eventos React
    window.location.reload();
  };

  const handlePrintIndividualForm = async () => {
    setExpandedRows(data.id_individualForm.map((_, index) => index));

    // Espera meio segundo para o React aplicar a expansão do DOM
    await sleep(500);

    const printContent = document.getElementById('print-area');
    if (!printContent) return;

    const originalContent = document.body.innerHTML;

    document.body.innerHTML = comMarca(printContent.innerHTML);
    window.print();
    document.body.innerHTML = originalContent;

    // Recarrega a página para restaurar estados e eventos React
    window.location.reload();
  };

  const handleEdit = async (index, res) => {
    setDay(`${res.day}`);
    setMonth(`${res.month}`);

    setEditingIndex(index);
    setEditingId(res._id);
    setEditedDescription(res.description);
  }

  const handleSaveEdit = async () => {
    try {
      const res = await updateRecordClassTaught(editedDescription, day, month, editingId);
      if (res.data) {
        alert('Aula atualizada com sucesso!');
        setLoading(true);
        setEditingIndex(null);
        setErrorMessage('');
        const updatedLessons = data.id_recordClassTaught.map((item) =>
          item._id === editingId
            ? { ...item, description: editedDescription, day, month }
            : item
        );

        // Atualiza `data` com nova lista de aulas
        setData((prev) => ({
          ...prev,
          id_recordClassTaught: updatedLessons
        }));
        setLoading(false);
      } else {
        setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
      }
    } catch (error) {
      console.error("Erro ao atualizar aula:", error);
      setErrorMessage('Ocorreu um erro ao salvar a edição. Tente novamente.');
    }
  };
  //if (loading || !data) return <LoadingSpinner />;

  function toggleAssessment(index) {
    setExpandedAssessments(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  }

  function groupGradesByMatter() {
    const grouped = {};

    if (!data?.studentGrade) return grouped;

    data.studentGrade.forEach((grade) => {
      const matter = grade.id_matter;
      const student = grade.id_student;

      if (!matter || !student) return;

      const matterId = matter._id;
      const studentId = student._id;

      const raw = grade.studentGrade;
      const gradeNumber = typeof raw === 'string'
        ? parseFloat(raw.replace(',', '.'))
        : Number(raw);

      const isHistorico = !grade.idActivity; // 🔑 REGRA PRINCIPAL

      if (!grouped[matterId]) {
        grouped[matterId] = {
          name: matter.name,
          students: {},
        };
      }

      if (!grouped[matterId].students[studentId]) {
        grouped[matterId].students[studentId] = {
          name: student.name,
          total: 0,
        };
      }

      if (isHistorico) {
        grouped[matterId].students[studentId].hasHistorico = true;
      }

      grouped[matterId].students[studentId].total += isNaN(gradeNumber) ? 0 : gradeNumber;
    });

    return grouped;
  }

  const groupedGradesRaw = groupGradesByMatter();

  // Reordena as matérias conforme a ordem definida pelo usuário (campo `order`
  // vindo do GetMatter), com a Educação Física no fim. Como Object.entries
  // preserva a ordem de inserção, todos os pontos que iteram groupedGrades
  // herdam essa ordem.
  const groupedGrades = (() => {
    const nrm = (s = '') =>
      s?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
    const orderIndex = new Map((matters || []).map((m, i) => [nrm(m.name), i]));
    const big = Number.MAX_SAFE_INTEGER;
    const entries = Object.entries(groupedGradesRaw).sort((a, b) => {
      const ia = orderIndex.has(nrm(a[1].name)) ? orderIndex.get(nrm(a[1].name)) : big;
      const ib = orderIndex.has(nrm(b[1].name)) ? orderIndex.get(nrm(b[1].name)) : big;
      return ia - ib;
    });
    return Object.fromEntries(entries);
  })();

  function normalize(str) {
    return str
      ?.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
  }

  console.log("data", data)
  const conceptsPhysical = (data?.studentConcept || []).filter(c =>
    normalize(c.id_matter?.name).includes('EDUCACAO FISICA')
  )

  // matérias dos conceitos (id + nome) únicas, ordenadas pela ordem do usuário
  // (campo `order` do GetMatter), com a Educação Física no fim.
  const orderedConceptMatters = (conceptList = []) => {
    const nrm = (s = '') =>
      s?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
    const orderIndex = new Map((matters || []).map((m, i) => [nrm(m.name), i]));
    const big = Number.MAX_SAFE_INTEGER;
    const uniq = Array.from(
      new Map(conceptList.map(c => [c.id_matter._id, c.id_matter.name])).entries()
    );
    return uniq.sort((a, b) => {
      const ia = orderIndex.has(nrm(a[1])) ? orderIndex.get(nrm(a[1])) : big;
      const ib = orderIndex.has(nrm(b[1])) ? orderIndex.get(nrm(b[1])) : big;
      return ia - ib;
    });
  };

  const groupedGradesPhysical = Object.fromEntries(
    Object.entries(groupedGrades).filter(([_, matterData]) =>
      normalize(matterData.name).includes('EDUCACAO FISICA')
    )
  )

  const handlePrintgrades = () => {
    const printContent = document.getElementById("printable-content");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Impressão</title>
            <style>
            .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { 
                text-align: center;
                border: 1px solid #ddd;
                font-size: 11px;
                padding: 1px; 
              }
                tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                  
                }
                .name-cell {
                    text-align: start;
                }
              @page {
                size: A4 landscape; /* Define o formato da página como paisagem */
                margin: 0;
              }  
              ContTable {
                overflow-x: hidden; /* Permite rolagem horizontal */
                width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                margin-left: auto; /* Centraliza horizontalmente */
                margin-right: auto; /* Centraliza horizontalmente */
              }
                .printable-content {
                  visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                  font-size: 15px;
                  //transform: scale(1); /* Ajusta a escala da tabela */
                }
              .data {
                display: flex;
                gap:15px;
              }
                .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
              .info {
                display: flex;
                flex-direction: column;
              }
                /* ✅ NOVO: estilo para a legenda com borda */
            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 90px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
                .no-print {
                  display: none !important;
                }
                  /* ✅ As regras de cor que faltavam */
                .grade-red { color: #dc2626; }
                .grade-blue { color: #2563eb; }
                .grade-green { color: #16a34a; }
            </style>
          </head>
          <body>
            ${comMarca(printContent.innerHTML)} 
          </body>
        </html>
      `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintgradesPhysical = () => {
    const printContent = document.getElementById("printable-content-physical");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Impressão</title>
            <style>
            .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
              body { font-family: Arial, sans-serif; margin: 20px; }
              table { width: 100%; border-collapse: collapse; }
              th, td { 
                text-align: center;
                border: 1px solid #ddd;
                font-size: 11px;
                padding: 1px; 
              }
                tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid;
                  
                }
                .name-cell {
                    text-align: start;
                }
              @page {
                size: A4 landscape; /* Define o formato da página como paisagem */
                margin: 0;
              }  
              ContTable {
                overflow-x: hidden; /* Permite rolagem horizontal */
                width: max-content; /* Garante que a tabela ocupe a largura do conteúdo */
                margin-left: auto; /* Centraliza horizontalmente */
                margin-right: auto; /* Centraliza horizontalmente */
              }
                .printable-content {
                  visibility: visible; /* Exibe apenas o conteúdo dentro desta classe */
                  font-size: 15px;
                  //transform: scale(1); /* Ajusta a escala da tabela */
                }
              .data {
                display: flex;
                gap:15px;
              }
                .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
              .info {
                display: flex;
                flex-direction: column;
              }
                /* ✅ NOVO: estilo para a legenda com borda */
            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 90px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
                .no-print {
                  display: none !important;
                }
                  /* ✅ As regras de cor que faltavam */
                .grade-red { color: #dc2626; }
                .grade-blue { color: #2563eb; }
                .grade-green { color: #16a34a; }
            </style>
          </head>
          <body>
            ${comMarca(printContent.innerHTML)} 
          </body>
        </html>
      `);

      printWindow.document.close();

      // Força um pequeno delay antes de chamar print()
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintconcept = () => {
    const printContent = document.getElementById("printable-content-concepts");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
      <html>
        <head>
          <title>Impressão de Conceitos</title>
          <style>
          .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td {
              text-align: center;
              border: 1px solid #ddd;
              font-size: 11px;
              padding: 1px;
            }
            tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid; }

            .name-cell {
              text-align: start;
            }

            @page {
              size: A4 landscape; /* Formato paisagem */
              margin: 0;
            }

            ConceptsTableContainer {
              overflow-x: hidden;
              width: max-content;
              margin-left: auto;
              margin-right: auto;
            }

            .printable-content-concepts {
              visibility: visible;
              font-size: 15px;
            }

            .data {
              display: flex;
              gap: 15px;
            }
            .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
            .info {
              display: flex;
              flex-direction: column;
            }

            .no-print {
              display: none !important;
            }

            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 120px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
            .concept-green { color: #1d7f14; }
            .concept-blue { color: blue; }
            .concept-orange { color: orange; }
            .concept-red { color: red; }
          </style>
        </head>
        <body>
          ${comMarca(printContent.innerHTML)}
        </body>
      </html>
    `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handlePrintconceptPhysical = () => {
    const printContent = document.getElementById("printable-content-concepts-physical");

    if (printContent) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
      <html>
        <head>
          <title>Impressão de Conceitos</title>
          <style>
          .logo-print {
                width: 150px !important;
                height: 150px !important;
              }
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; }
            th, td {
              text-align: center;
              border: 1px solid #ddd;
              font-size: 11px;
              padding: 1px;
            }
            tr { page-break-inside: avoid; break-inside: avoid; -webkit-region-break-inside: avoid; }

            .name-cell {
              text-align: start;
            }

            @page {
              size: A4 landscape; /* Formato paisagem */
           margin: 0;
            }

            ConceptsTableContainer {
              overflow-x: hidden;
              width: max-content;
              margin-left: auto;
              margin-right: auto;
            }

            .printable-content-concepts {
              visibility: visible;
              font-size: 15px;
            }

            .data {
              display: flex;
              gap: 15px;
            }
            .HeaderWrapper {
                    display: flex;
                    gap: 40px
                  }
            .info {
              display: flex;
              flex-direction: column;
            }

            .no-print {
              display: none !important;
            }

            .legendBox {
              border: 1px solid black !important;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: 10px;
              background: white !important;
              color: black !important;
              box-shadow: none !important;
              max-width: 400px;
              height: 120px;
            }
              .legendBox h3 {
              margin: 0;
              text-align: center;
            }

            .legendBox p {
              margin: 5px 0;
            }
            .concept-green { color: #1d7f14; }
            .concept-blue { color: blue; }
            .concept-orange { color: orange; }
            .concept-red { color: red; }
          </style>
        </head>
        <body>
          ${comMarca(printContent.innerHTML)}
        </body>
      </html>
    `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const handleSaveEditIndForm = async () => {
    try {
      const res = await FormEdit({ update_idForm: editingId, editedDescription });

      if (res) {
        alert('Ficha atualizada com sucesso!');
        setLoading(true);

        setEditingIndex(null);

        setErrorMessage('');
        window.location.reload()
      } else {
        setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
      }
    } catch (error) {
      console.error("Erro ao atualizar aula:", error);
      setErrorMessage('Ocorreu um erro ao salvar a edição. Tente novamente.');
    }
  };

  const renderPeriod = (bimonthly) => {
    if (!bimonthly) return ''

    return assessmentRegime === 'TRIMESTRAL'
      ? bimonthly.replace(/Bimestre/gi, 'Trimestre')
      : bimonthly.replace(/Trimestre/gi, 'Bimestre')
  }

  return (
    <Container>
      {loading ?
        <LoadingSpinner />
        :
        <>
          {/* diário ainda aberto: tudo o que já está gravado, marcado como prévia (sai também na impressão) */}
          {previa && (
            <div style={{
              width: '100%', boxSizing: 'border-box', border: '2px solid #b45309', background: '#fff4e5', color: '#7c2d12',
              fontWeight: 800, fontSize: 15, textAlign: 'center', padding: '8px 12px', margin: '0 0 6px',
              WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact',
            }}>
              PRÉVIA — diário não fechado
              <div style={{ fontWeight: 600, fontSize: 12.5 }}>
                Mostra tudo o que já está gravado neste período. O diário oficial é gerado quando o diário for fechado.
              </div>
            </div>
          )}
          {/* Botões de navegação no topo */}
          <Butons>

            <UpperButons>
              <Btt02
                className={isActive('attendanceList') ? 'active' : ''}
                onClick={() => handleComponentChange('attendanceList')}
              >
                Frequência
              </Btt02>
              <Btt02 className={isActive('classes') ? 'active' : ''}
                onClick={() => handleComponentChange('classes')}
              >
                Aulas Lecionadas
              </Btt02>
              {assessmentFormat !== 'grade' ? (
                <ButtonGroup>
                  <Btt02
                    className={isActive('concepts') ? 'active' : ''}
                    onClick={() => handleComponentChange('concepts')}
                  >
                    Conceitos
                  </Btt02>
                  <Btt02
                    className={isActive('individualRecords') ? 'active' : ''}
                    onClick={() => handleComponentChange('individualRecords')}
                  >
                    Relatórios Individuais
                  </Btt02>
                </ButtonGroup>
              ) : (
                <ButtonGroup>
                  <Btt02 className={isActive('assessments') ? 'active' : ''}
                    onClick={() => handleComponentChange('assessments')}
                  >
                    Avaliações
                  </Btt02>
                  <Btt02
                    className={isActive('numericalGrades') ? 'active' : ''}
                    onClick={() => handleComponentChange('numericalGrades')}
                  >
                    Notas
                  </Btt02>
                </ButtonGroup>
              )}

            </UpperButons>

            {/*assessmentFormat !== "grade"
              &&
              <BottomButons>

                <Btt02
                  className={isActive('finalConcepts') ? 'active' : ''}
                  onClick={() => handleComponentChange('finalConcepts')}
                >
                  Conceitos Finais
                </Btt02>
              </BottomButons>
            */}

          </Butons>

          {activeComponent === 'attendanceList' && (
            data?.attendance?.length > 0 ? (
              <>
                <AttendanceContainer id="printable-content-attendance" className="printable-content-attendance">
                  <HeaderWrapper className="HeaderWrapper">

                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <span><strong>Escola:</strong> {data.nameSchool}</span>

                      <span><strong>Ano:</strong> {data.year}</span>
                      {data?.serie && (
                        <span>
                          <strong>Série:</strong> {data.serie} - {data.idClass.level}
                        </span>
                      )}
                      <span><strong>Turma:</strong> {data.nameClass}</span>
                      <span><strong>Professor(a) Titular:</strong> {data.nameRegentTeacher}</span>
                      {data.nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor(a) Adjunto:</strong> {data.nameRegentTeacher02}</span>
                      )}
                      {/*data.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor de Ed. Física:</strong> {data.namephysicalEducationTeacher}</span>
                      )*/}
                    </ContInfo>
                  </HeaderWrapper>
                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintAttendance}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  <h2>Frequências do {renderPeriod(bimonthly)} (Professor Regente)</h2>
                  <ContTable>
                    <Table>
                      <TableHeader>
                        {/* 🔹 Linha dos meses */}
                        <tr>
                          <th className="name-cell" rowSpan={2}>Nome do Aluno</th>

                          {Object.entries(groupedByMonth).map(([month, dates], index) => (
                            <th
                              key={month}
                              colSpan={dates.length}
                              className={index % 2 === 0 ? "month-alt" : "month-normal"}
                            >
                              {getMonthName(Number(month))}
                            </th>
                          ))}

                          <th className="total-presence" rowSpan={2}>Total P</th>
                          <th className="total-absence" rowSpan={2}>Total F</th>
                          <th className="total-justifiedAbsence" rowSpan={2}>Total FJ</th>
                        </tr>

                        {/* 🔹 Linha dos dias */}
                        <tr>
                          {allDatesFlat.map(({ date, isAlt }, idx) => (
                            <th
                              key={idx}
                              className={isAlt ? "month-alt" : "month-normal"}
                            >
                              {date.split("-")[2]}
                            </th>
                          ))}
                        </tr>
                      </TableHeader>
                      <TableBody>
                        {data.id_student
                          .sort((a, b) =>
                            normalizeString(a.name).localeCompare(normalizeString(b.name))
                          )
                          .map((student) => {
                            const totals = calculateTotals(student._id);
                            return (
                              <tr
                                key={student._id}
                                onClick={() => handleRowClick(student._id)}
                                className={selectedStudentId === student._id ? 'selected-row' : ''}
                              >
                                <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                                {allDatesFlat.map(({ date, isAlt }) => {
                                  const cell = getAttendanceStatus(student._id, date);

                                  return React.cloneElement(cell, {
                                    className: `${cell.props.className} ${isAlt ? "month-alt" : "month-normal"
                                      }`,
                                  });
                                })}
                                <td className="total-presence">{totals.totalPresence}</td>
                                <td className="total-absence">{totals.totalAbsence}</td>
                                <td className="total-justifiedAbsence">{totals.totalJustified}</td>
                              </tr>
                            );
                          })}
                        {data.transferStudents && data.transferStudents.length > 0 && (
                          <>
                            <tr>
                              <td
                                colSpan={allDatesFlat.length + 4}
                                style={{
                                  textAlign: "left",
                                  fontWeight: "bold",
                                  padding: "5px",
                                  background: "#f8d7da",
                                  color: "#721c24",
                                }}
                              >
                                ⚠️ Alunos Transferidos e Remanejados
                              </td>
                            </tr>
                            {data.transferStudents
                              .sort((a, b) =>
                                normalizeString(a.name).localeCompare(normalizeString(b.name))
                              )
                              .map((student) => {
                                const totals = calculateTotals(student._id);
                                return (
                                  <tr key={student._id}
                                    onClick={() => handleRowClick(student._id)}
                                    className={selectedStudentId === student._id ? 'selected-row' : ''}
                                  >
                                    <td className="name-cell">
                                      {student.name}{" "}
                                      {student.status === "ativo" && (
                                        <span style={{ color: "blue", fontWeight: "bold" }}>
                                          Remanejado
                                        </span>
                                      )}
                                      {student.status === "inativo" && (
                                        <span style={{ color: "blue", fontWeight: "bold" }}>
                                          Remanejado
                                        </span>
                                      )}
                                      {student.status === "transferido" && (
                                        <span style={{ color: "orange", fontWeight: "bold" }}>
                                          Transferido
                                        </span>
                                      )}
                                      <BirthDate cpf={student.cpf} dob={student.dateOfBirth} />
                                    </td>
                                    {allDatesFlat.map(({ date, isAlt }) => {
                                      const cell = getAttendanceStatus(student._id, date);

                                      return React.cloneElement(cell, {
                                        className: `${cell.props.className} ${isAlt ? "month-alt" : "month-normal"
                                          }`,
                                      });
                                    })}
                                    <td className="total-presence">{totals.totalPresence}</td>
                                    <td className="total-absence">{totals.totalAbsence}</td>
                                    <td className="total-justifiedAbsence">{totals.totalJustified}</td>
                                  </tr>
                                );
                              })}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </ContTable>
                </AttendanceContainer>
                <AttendanceContainer id="printable-content-attendancePhysicalEducation" className="printable-content-attendance">
                  <HeaderWrapper className="HeaderWrapper">

                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <span><strong>Escola:</strong> {data.nameSchool}</span>

                      <span><strong>Ano:</strong> {data.year}</span>
                      {data?.serie && (
                        <span>
                          <strong>Série:</strong> {data.serie} - {data.idClass.level}
                        </span>
                      )}
                      <span><strong>Turma:</strong> {data.nameClass}</span>
                      {/*<span><strong>Professor Regente:</strong> {data.nameRegentTeacher}</span>*/}
                      {/*data.nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor Regente 02:</strong> {data.nameRegentTeacher02}</span>
                      )*/}
                      {data.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor(a) de Ed. Física:</strong> {data.namephysicalEducationTeacher}</span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>
                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintAttendancePhysicalEducation}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  {/* Frequência do professor de Educação Física */}
                  <h2>Frequências do {renderPeriod(bimonthly)} (Professor de Educação Física)</h2>
                  <ContTable>
                    <Table>
                      <TableHeader>
                        <tr>
                          <th className="name-cell" rowSpan={2}>Nome do Aluno</th>

                          {Object.entries(groupedByMonthPhysical).map(([month, dates], index) => (
                            <th
                              key={month}
                              colSpan={dates.length}
                              className={index % 2 === 0 ? "month-alt" : "month-normal"}
                            >
                              {getMonthName(Number(month))}
                            </th>
                          ))}

                          <th className="total-presence" rowSpan={2}>Total P</th>
                          <th className="total-absence" rowSpan={2}>Total F</th>
                          <th className="total-justifiedAbsence" rowSpan={2}>Total FJ</th>
                        </tr>

                        <tr>
                          {allDatesFlatPhysical.map(({ date, isAlt }, idx) => (
                            <th
                              key={idx}
                              className={isAlt ? "month-alt" : "month-normal"}
                            >
                              {date.split("-")[2]}
                            </th>
                          ))}
                        </tr>
                      </TableHeader>
                      <TableBody>
                        {data.id_student
                          .sort((a, b) =>
                            normalizeString(a.name).localeCompare(normalizeString(b.name))
                          )
                          .map((student) => {
                            const totals = calculateTotalsPhysical(student._id);
                            return (
                              <tr
                                key={student._id}
                                onClick={() => handleRowClick(student._id)}
                                className={selectedStudentId === student._id ? 'selected-row' : ''}
                              >
                                <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                                {allDatesFlatPhysical.map(({ date, isAlt }) => {
                                  const cell = getAttendanceStatusPhysical(student._id, date);

                                  return React.cloneElement(cell, {
                                    className: `${cell.props.className} ${isAlt ? "month-alt" : "month-normal"
                                      }`,
                                  });
                                })}
                                <td className="total-presence">{totals.totalPresence}</td>
                                <td className="total-absence">{totals.totalAbsence}</td>
                                <td className="total-justifiedAbsence">{totals.totalJustified}</td>
                              </tr>
                            );
                          })}
                        {/* 🔹 Alunos transferidos/remanejados */}
                        {data.transferStudents && data.transferStudents.length > 0 && (
                          <>
                            <tr>
                              <td
                                colSpan={allDatesFlatPhysical.length + 4}
                                style={{
                                  textAlign: "left",
                                  fontWeight: "bold",
                                  padding: "5px",
                                  background: "#f8d7da",
                                  color: "#721c24",
                                }}
                              >
                                ⚠️ Alunos Transferidos e Remanejados (Ed. Física)
                              </td>
                            </tr>
                            {data.transferStudents
                              .sort((a, b) =>
                                normalizeString(a.name).localeCompare(normalizeString(b.name))
                              )
                              .map((student) => {
                                const totals = calculateTotalsPhysical(student._id);
                                return (
                                  <tr key={student._id}>
                                    <td className="name-cell">
                                      {student.name}{" "}
                                      {student.status === "ativo" && (
                                        <span style={{ color: "blue", fontWeight: "bold" }}>
                                          Remanejado
                                        </span>
                                      )}
                                      {student.status === "inativo" && (
                                        <span style={{ color: "blue", fontWeight: "bold" }}>
                                          Remanejado
                                        </span>
                                      )}
                                      {student.status === "transferido" && (
                                        <span style={{ color: "orange", fontWeight: "bold" }}>
                                          Transferido
                                        </span>
                                      )}
                                      <BirthDate cpf={student.cpf} dob={student.dateOfBirth} />
                                    </td>
                                    {allDatesFlatPhysical.map(({ date, isAlt }) => {
                                      const cell = getAttendanceStatusPhysical(student._id, date);

                                      return React.cloneElement(cell, {
                                        className: `${cell.props.className} ${isAlt ? "month-alt" : "month-normal"
                                          }`,
                                      });
                                    })}
                                    <td className="total-presence">{totals.totalPresence}</td>
                                    <td className="total-absence">{totals.totalAbsence}</td>
                                    <td className="total-justifiedAbsence">{totals.totalJustified}</td>
                                  </tr>
                                );
                              })}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </ContTable>
                </AttendanceContainer>
              </>
            ) : (
              <div style={{ padding: "2rem", textAlign: "center" }}>
                <h2>Nenhum dado de frequência encontrado para o {renderPeriod(bimonthly)}.</h2>
                <p>Verifique se a turma teve aulas cadastradas com frequência registrada.</p>
              </div>
            )
          )}

          {activeComponent === 'classes' && (
            <>
              {/* 📘 AULAS DO PROFESSOR REGENTE (TITULAR / ADJUNTO) */}
              <StudentSection id='print-area'>

                <LessonsContainer>
                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintClasses}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  <ContLogo className="cont-logo-classes">
                    {logoUrl && <Preview className="logo-classes" src={logoUrl} alt="Logo da escola" />}
                    <h2>Registros de Aulas do {renderPeriod(bimonthly)} — Professor Regente</h2>
                  </ContLogo>

                  <ContInfo className="info">
                    <span><strong>Escola:</strong> {data.nameSchool}</span>
                  </ContInfo>

                  <h4 className="total-aulas-lecionadas">
                    Total de aulas lecionadas: {
                      data?.id_recordClassTaught?.filter((res) => {

                        if (res?.teacher_type) {
                          return res.teacher_type === "REGENTE";
                        }

                        return (
                          data?.idRegentTeacher?.some(
                            (id) => id?.toString() === res?.id_teacher?._id?.toString()
                          ) ||
                          data?.idRegentTeacher02?.some(
                            (id) => id?.toString() === res?.id_teacher?._id?.toString()
                          )
                        );

                      }).length || 0
                    }
                  </h4>

                  <>
                    {data?.id_recordClassTaught?.length > 0 ? (
                      console.log("aulas", data.id_recordClassTaught),
                      data.id_recordClassTaught
                        .filter((res) => {
                          const hasTeacherType = !!res?.teacher_type;

                          if (hasTeacherType) {
                            return res.teacher_type === "REGENTE";
                          }

                          const isRegent1 =
                            Array.isArray(data.idRegentTeacher) &&
                            data.idRegentTeacher.some(
                              (id) => id?.toString() === res?.id_teacher?._id?.toString()
                            );

                          const isRegent2 =
                            Array.isArray(data.idRegentTeacher02) &&
                            data.idRegentTeacher02.some(
                              (id) => id?.toString() === res?.id_teacher?._id?.toString()
                            );

                          return isRegent1 || isRegent2;
                        })
                        .sort((a, b) => new Date(a.year, a.month - 1, a.day) - new Date(b.year, b.month - 1, b.day))
                        .slice(0, expandedSections.regent ? undefined : 3)
                        .map((res, index) => (
                          <React.Fragment key={`regent-${index}`}>
                            <ContainerTable className="print-container-table">
                              <Span>
                                {
                                  res?.teacher_type === "REGENTE" ? (
                                    // ✅ AULA NOVA
                                    <>
                                      {res?.id_teacher && (
                                        <div>
                                          Professor(a) Titular:
                                          <p>{res.id_teacher.name}</p>
                                        </div>
                                      )}

                                      {res?.id_teacher02 && (
                                        <div>
                                          Professor(a) Adjunto:
                                          <p>{res.id_teacher02.name}</p>
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    // ✅ AULA ANTIGA (sua regra original)
                                    Array.isArray(data.idRegentTeacher) &&
                                      data.idRegentTeacher
                                        .map(id => id.toString())
                                        .includes(res?.id_teacher?._id?.toString?.()) ? (
                                      <>
                                        <div>
                                          Professor(a) Titular:
                                          <p>{res.id_teacher.name}</p>
                                        </div>

                                        {data.nameRegentTeacher02 &&
                                          data.nameRegentTeacher02 !== "Professor não definido" && (
                                            <div>
                                              Professor(a) Adjunto:
                                              <p>{data.nameRegentTeacher02}</p>
                                            </div>
                                          )}
                                      </>
                                    ) : (
                                      <>
                                        {data.nameRegentTeacher &&
                                          data.nameRegentTeacher !== "Professor não definido" && (
                                            <div>
                                              Professor(a) Titular:
                                              <p>{data.nameRegentTeacher}</p>
                                            </div>
                                          )}

                                        <div>
                                          Professor(a) Adjunto:
                                          <p>{res.id_teacher.name}</p>
                                        </div>
                                      </>
                                    )
                                  )
                                }

                                {data?.serie && (
                                  <span>
                                    <div>Serie: <p>{data.serie} - {data.idClass.level}</p></div>
                                  </span>
                                )}
                                <div>Turma: <p>{data.nameClass}</p></div>
                              </Span>

                              <TableRow>
                                <DateCell>{`${res.day}/${res.month}/${res.year}`}</DateCell>
                                <DescriptionCell>
                                  <div className={`description ${expandedRows.includes(index) ? 'expanded' : 'collapsed'}`}>
                                    <div
                                      style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                      dangerouslySetInnerHTML={{
                                        __html: expandedRows.includes(index) || printing
                                          ? res.description
                                          : getDescriptionPreview(res.description)
                                      }}
                                    />
                                  </div>

                                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {!printing && (
                                      <Button onClick={() => toggleRowExpansion(index)} className={HiddenOnPrint}>
                                        {expandedRows.includes(index) ? 'Ver Menos' : 'Ver Mais'}
                                      </Button>
                                    )}
                                    {expandedRows.includes(index) && positionAtSchool === 'DIRETOR/SUPERVISOR' && (
                                      <Button onClick={() => handleEdit(index, res)} className={HiddenOnPrint}>
                                        Editar
                                      </Button>
                                    )}
                                  </div>
                                </DescriptionCell>
                              </TableRow>
                              {editingIndex === index && (
                                <EditContainer>
                                  <div className="modal-content">
                                    <h3>Editando Aula</h3>
                                    <ReactQuill
                                      theme="snow"
                                      modules={{
                                        toolbar: [
                                          [{ 'font': [] }],
                                          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                          ['bold', 'italic', 'underline'],
                                          [{ 'color': [] }, { 'background': [] }],
                                          ['clean']
                                        ]
                                      }}
                                      value={editedDescription}
                                      onChange={(e) => setEditedDescription(e)}
                                      placeholder="Descrição da aula"
                                      style={{
                                        height: 'auto', // aumentado de 250px para 350px
                                        maxHeight: '550px',
                                        overflow: 'auto',
                                        zIndex: 0,
                                        position: 'relative'
                                      }}
                                    />
                                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                    <div style={{ position: 'relative', zIndex: 10, marginTop: '30px', }} className='BoxBtt'>
                                      <ButtonEdit onClick={handleSaveEdit}>Salvar</ButtonEdit>
                                      <ButtonEdit onClick={() => setEditingIndex(null)}>Cancelar</ButtonEdit>
                                    </div>
                                  </div>
                                </EditContainer>
                              )}
                            </ContainerTable>
                          </React.Fragment>
                        ))
                    ) : (
                      <InfoText>Nenhum registro de aulas encontrado para os professores regentes.</InfoText>
                    )}
                  </>
                  <h3
                    style={{ cursor: "pointer", textAlign: "center", marginBottom: "1rem" }}
                    onClick={() => toggleSection('regent')}
                    className="no-print"
                  >
                    {expandedSections.regent
                      ? "► Ver menos aulas"
                      : "▼ Ver todas as aulas"}
                  </h3>
                </LessonsContainer>
                <PrintStyleLessons />
              </StudentSection>

              {/* 🏃‍♂️ AULAS DO PROFESSOR DE EDUCAÇÃO FÍSICA */}
              <StudentSection id='print-areaEdFisica'>
                <LessonsContainer>
                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintClassesEdFisica}>Imprimir</ButtonPrint>
                  </CtnrBtt>
                  <ContLogo className="cont-logo-classes">
                    {logoUrl && <Preview className="logo-classes" src={logoUrl} alt="Logo da escola" />}
                    <h2>Registros de Aulas do {renderPeriod(bimonthly)} — Educação Física</h2>
                  </ContLogo>

                  <ContInfo className="info">
                    <span><strong>Escola:</strong> {data.nameSchool}</span>
                  </ContInfo>

                  <h4 className="total-aulas-lecionadas">
                    Total de aulas lecionadas: {
                      data?.id_recordClassTaught?.filter((res) => {

                        if (res?.teacher_type) {
                          return res.teacher_type === "ED_FISICA";
                        }

                        return (
                          data?.idPhysicalEducationTeacher?.some(
                            (id) => id?.toString() === res?.id_teacher?._id?.toString()
                          )
                        );

                      }).length || 0
                    }
                  </h4>

                  <>
                    {data?.id_recordClassTaught?.length > 0 ? (
                      data.id_recordClassTaught
                        .filter((res) => {

                          // 🔹 Se já tem teacher_type (registro novo)
                          if (res?.teacher_type) {
                            return res.teacher_type === "ED_FISICA";
                          }

                          // 🔹 Se não tem teacher_type (registro antigo)
                          return data?.idPhysicalEducationTeacher?.some(
                            (id) => id?.toString() === res?.id_teacher?._id?.toString()
                          );

                        })

                        .sort((a, b) => new Date(a.year, a.month - 1, a.day) - new Date(b.year, b.month - 1, b.day))
                        .slice(0, expandedSections.edfisica ? undefined : 3)
                        .map((res, index) => (
                          <React.Fragment key={`pe-${index}`}>
                            <ContainerTable className="print-container-table">
                              <Span>
                                <div>Professor(a) de Ed. Física: <p>{res.id_teacher.name}</p></div>
                                {data?.serie && (
                                  <span>
                                    <div>Serie: <p>{data.serie} - {data.idClass.level}</p></div>
                                  </span>
                                )}
                                <div>Turma: <p>{data.nameClass}</p></div>
                              </Span>

                              <TableRow>
                                <DateCell>{`${res.day}/${res.month}/${res.year}`}</DateCell>
                                <DescriptionCell>
                                  <div className={`description ${expandedRows.includes(index) ? 'expanded' : 'collapsed'}`}>
                                    <div
                                      style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                      dangerouslySetInnerHTML={{
                                        __html: expandedRows.includes(index) || printing
                                          ? res.description
                                          : getDescriptionPreview(res.description)
                                      }}
                                    />
                                  </div>

                                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {!printing && (
                                      <Button onClick={() => toggleRowExpansion(index)} className={HiddenOnPrint}>
                                        {expandedRows.includes(index) ? 'Ver Menos' : 'Ver Mais'}
                                      </Button>
                                    )}
                                    {expandedRows.includes(index) && positionAtSchool === 'DIRETOR/SUPERVISOR' && (
                                      <Button onClick={() => handleEdit(index, res)} className={HiddenOnPrint}>
                                        Editar
                                      </Button>
                                    )}
                                  </div>
                                </DescriptionCell>
                              </TableRow>
                              {editingIndex === index && (
                                <EditContainer>
                                  <div className="modal-content">
                                    <h3>Editando Aula</h3>
                                    <ReactQuill
                                      theme="snow"
                                      modules={{
                                        toolbar: [
                                          [{ 'font': [] }],
                                          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                          ['bold', 'italic', 'underline'],
                                          [{ 'color': [] }, { 'background': [] }],
                                          ['clean']
                                        ]
                                      }}
                                      value={editedDescription}
                                      onChange={(e) => setEditedDescription(e)}
                                      placeholder="Descrição da aula"
                                      style={{
                                        height: 'auto', // aumentado de 250px para 350px
                                        maxHeight: '550px',
                                        overflow: 'auto',
                                        zIndex: 0,
                                        position: 'relative'
                                      }}
                                    />
                                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                    <div style={{ position: 'relative', zIndex: 10, marginTop: '30px', }} className='BoxBtt'>
                                      <ButtonEdit onClick={handleSaveEdit}>Salvar</ButtonEdit>
                                      <ButtonEdit onClick={() => setEditingIndex(null)}>Cancelar</ButtonEdit>
                                    </div>
                                  </div>
                                </EditContainer>
                              )}
                            </ContainerTable>
                          </React.Fragment>
                        ))
                    ) : (
                      <InfoText>Nenhum registro de aulas encontrado para o professor de Educação Física.</InfoText>
                    )}
                  </>
                  <h3
                    className="no-print"
                    style={{ cursor: "pointer", textAlign: "center", marginBottom: "1rem" }}
                    onClick={() => toggleSection('edfisica')}
                  >
                    {expandedSections.edfisica
                      ? "► Ver menos aulas"
                      : "▼ Ver todas as aulas"}
                  </h3>
                </LessonsContainer>

                <PrintStyleLessons />
              </StudentSection>
            </>
          )}

          {activeComponent === 'assessments' && (
            <>
              {data?.idActivity?.length > 0 ? (
                <AssessmentsContainer>
                  <h2>Avaliações do {renderPeriod(data.bimonthly)}</h2>

                  {data.idActivity
                    .slice() // cria uma cópia para não mutar o array original
                    .sort((a, b) => {
                      const nameA = a?.id_matter?.name?.toLowerCase() || '';
                      const nameB = b?.id_matter?.name?.toLowerCase() || '';
                      if (nameA < nameB) return -1;
                      if (nameA > nameB) return 1;
                      return 0;
                    })
                    .map((activity, index) => (
                      <div key={index} className="assessment-item">
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Disciplina:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity?.id_matter?.name || 'Não informado'}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Descrição:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity.descricao}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Tipo:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity.tipo}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '4px' }}>
                          <strong style={{ marginRight: '6px' }}>Valor:</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity.valor.toFixed(1).replace('.', ',')}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '8px' }}>
                          <strong style={{ marginRight: '6px' }}>Professor(a):</strong>
                          <span style={{ wordBreak: 'break-word' }}>
                            {activity?.id_teacher?.name || 'Não informado'}
                          </span>
                        </div>
                        <div style={{ marginTop: '8px', textAlign: 'right' }}>
                          <button
                            onClick={() => toggleAssessment(index)}
                            style={{
                              background: '#007bff',
                              color: 'white',
                              border: 'none',
                              padding: '6px 12px',
                              borderRadius: '6px',
                              cursor: 'pointer',
                            }}
                          >
                            {expandedAssessments.includes(index) ? 'Fechar Notas' : 'Ver Notas'}
                          </button>
                        </div>
                        {expandedAssessments.includes(index) && (
                          <>
                            {activity.studentGrades && activity.studentGrades.length > 0 ? (
                              <table>
                                <thead>
                                  <tr>
                                    <th>Aluno</th>
                                    <th>Nota</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {activity.studentGrades.map((grade, idx) => (
                                    <tr key={idx}>
                                      <td>{grade?.id_student?.name || 'Aluno não informado'}</td>
                                      <td>
                                        {grade.studentGrade
                                          ? (typeof grade.studentGrade === 'number'
                                            ? grade.studentGrade.toFixed(1).replace('.', ',')
                                            : Number(grade.studentGrade.replace(',', '.')).toFixed(1).replace('.', ','))
                                          : '-'}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>

                              </table>
                            ) : (
                              <p>Nenhuma nota registrada para esta avaliação.</p>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                </AssessmentsContainer>
              ) : (
                <InfoText>
                  Nenhum dado de Avaliações encontrado para o {renderPeriod(data.bimonthly)}.
                </InfoText>
              )}
            </>
          )}

          {activeComponent === 'numericalGrades' && (
            <>
              <GradesTableContainer id="printable-content">
                <HeaderWrapper className="HeaderWrapper">
                  {(logoUrl) && (
                    <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                  )}
                  <ContInfo className="info">
                    <h2>Registro de Notas do {renderPeriod(bimonthly)}</h2>
                    <span><strong>Escola:</strong> {data.nameSchool}</span>

                    <span><strong>Ano:</strong> {data.year}</span>
                    {data?.serie && (
                      <span><strong>Serie:</strong> {data.serie} - {data.idClass.level}</span>
                    )}
                    <span><strong>Turma:</strong> {data.nameClass}</span>
                    <span><strong>Professor(a) Titular:</strong> {data.nameRegentTeacher}</span>
                    {data.nameRegentTeacher02 !== "Professor não definido" && (
                      <span><strong>Professor(a) Adjunto:</strong> {data.nameRegentTeacher02}</span>
                    )}
                    {/*data.namephysicalEducationTeacher !== "Professor não definido" && (
                      <span><strong>Professor de Ed. Física:</strong> {data.namephysicalEducationTeacher}</span>
                    )*/}
                  </ContInfo>
                </HeaderWrapper>
                <CtnrBtt>
                  <ButtonPrint className="no-print" onClick={handlePrintgrades}>Imprimir</ButtonPrint>
                </CtnrBtt>
                <LegendaNotas total={parseFloat(data.totalGrade).toFixed(1)} media={parseFloat(data.averageGrade).toFixed(1)} />
                {Object.entries(groupedGrades).length > 0 ? (
                  console.log("groupedGrades", groupedGrades),
                  <div style={{ overflowX: 'auto' }}>
                    <GradesTable>
                      <GradesTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>
                          {Object.entries(groupedGrades).map(([matterId, matterData]) => (
                            <th key={matterId} className="matter-cell">
                              {matterData.name}
                            </th>
                          ))}
                        </tr>
                      </GradesTableHeader>
                      <GradesTableBody>
                        {Object.values(
                          Object.entries(groupedGrades).reduce((acc, [, matterData]) => {
                            Object.entries(matterData.students).forEach(([studentId, studentData]) => {
                              if (!acc[studentId]) {
                                acc[studentId] = { id: studentId, name: studentData.name, grades: {} };
                              }
                              acc[studentId].grades[matterData.name] = {
                                total: studentData.total,
                                hasHistorico: studentData.hasHistorico === true
                              };
                            });
                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem nota,
                          // para que apareçam na lista (com "-" nas matérias sem nota)
                          (data.id_student || []).reduce((acc, student) => {
                            acc[student._id] = { id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, grades: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student.name}
                              className={`grade-row ${selectedStudentGrades === student.name ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentGrades((prev) =>
                                  prev === student.name ? null : student.name
                                )
                              }
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                              {Object.entries(groupedGrades).map(([_, matterData]) => {
                                const notaObj = student.grades[matterData.name];
                                let notaClass = '';

                                if (notaObj) {
                                  // parse robusto: aceita "18", "18,00", "18.00", "18,5", com espaços, etc.
                                  const parseNota = (v) => {
                                    const s = String(v ?? '').trim().replace(/[^\d.,-]/g, '');
                                    const norm = s.includes(',') && s.includes('.')
                                      ? s.replace(/\./g, '').replace(',', '.') // 1.234,56 -> 1234.56
                                      : s.replace(',', '.');                   // 18,00 -> 18.00
                                    return parseFloat(norm);
                                  };
                                  const nota = parseNota(notaObj.total);
                                  const isHistorico = notaObj.hasHistorico === true;

                                  const notaTotal = parseNota(data.totalGrade);
                                  const notaMedia = parseNota(data.averageGrade);

                                  if (isHistorico) {
                                    notaClass = 'grade-historico';
                                  } else if (nota >= notaTotal * 0.9) {
                                    notaClass = 'grade-green';
                                  } else if (nota >= notaMedia) {
                                    notaClass = 'grade-blue';
                                  } else {
                                    notaClass = 'grade-red';
                                  }
                                }

                                return (
                                  <td
                                    key={matterData.name}
                                    className={`matter-cell ${notaClass}`}
                                  >
                                    {notaObj
                                      ? <NotaComRec nota={notaObj.total} rec={recFinal(idBimonthly, student.id, matterData.name, notaObj.total, data.averageGrade)} virgula />
                                      : '-'}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </GradesTableBody>
                    </GradesTable>
                  </div>
                ) : (
                  <GradesTable>
                    <tr><td>Não há nenhum registro</td></tr>
                  </GradesTable>
                )}
              </GradesTableContainer>

              <GradesTableContainer id="printable-content-physical">
                <HeaderWrapper className="HeaderWrapper">
                  {(logoUrl) && (
                    <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                  )}

                  <ContInfo className="info">
                    <h2>
                      Registro de Notas do {renderPeriod(bimonthly)} (Educação Física)
                    </h2>

                    <span><strong>Escola:</strong> {data.nameSchool}</span>
                    <span><strong>Ano:</strong> {data.year}</span>

                    {data?.serie && (
                      <span><strong>Série:</strong> {data.serie} - {data.idClass.level}</span>
                    )}

                    <span><strong>Turma:</strong> {data.nameClass}</span>

                    {data.namephysicalEducationTeacher !== "Professor não definido" && (
                      <span>
                        <strong>Professor(a) de Ed. Física:</strong> {data.namephysicalEducationTeacher}
                      </span>
                    )}
                  </ContInfo>
                </HeaderWrapper>

                <CtnrBtt>
                  <ButtonPrint className="no-print" onClick={handlePrintgradesPhysical}>
                    Imprimir
                  </ButtonPrint>
                </CtnrBtt>

                <LegendBox className="legendBox">
                  <h3>Legenda</h3>
                  <p>
                    Nota Total:{" "}
                    <strong style={{ color: '#1d7f14' }}>
                      {parseFloat(data.totalGrade).toFixed(1)}
                    </strong>
                  </p>
                  <p>
                    Nota Média:{" "}
                    <strong style={{ color: 'blue' }}>
                      {parseFloat(data.averageGrade).toFixed(1)}
                    </strong>
                  </p>
                </LegendBox>

                {Object.entries(groupedGradesPhysical).length > 0 ? (
                  <div style={{ overflowX: 'auto' }}>
                    <GradesTable>
                      <GradesTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>

                          {Object.entries(groupedGradesPhysical).map(([matterId, matterData]) => (
                            <th key={matterId} className="matter-cell">
                              {matterData.name}
                            </th>
                          ))}
                        </tr>
                      </GradesTableHeader>

                      <GradesTableBody>
                        {Object.values(
                          Object.entries(groupedGradesPhysical).reduce((acc, [, matterData]) => {
                            Object.entries(matterData.students).forEach(([studentId, studentData]) => {
                              if (!acc[studentId]) {
                                acc[studentId] = { id: studentId, name: studentData.name, grades: {} };
                              }

                              acc[studentId].grades[matterData.name] = {
                                total: studentData.total,
                                hasHistorico: studentData.hasHistorico === true
                              };
                            });

                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem conceito
                          (data.id_student || []).reduce((acc, student) => {
                            acc[student._id] = { id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, grades: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              className={`grade-row ${selectedStudentGrades === student.name ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentGrades((prev) =>
                                  prev === student.name ? null : student.name
                                )
                              }
                              key={student.name}
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>

                              {Object.entries(groupedGradesPhysical).map(([_, matterData]) => {
                                const notaObj = student.grades[matterData.name];

                                let notaClass = '';

                                if (notaObj) {
                                  // parse robusto: aceita "18", "18,00", "18.00", "18,5", com espaços, etc.
                                  const parseNota = (v) => {
                                    const s = String(v ?? '').trim().replace(/[^\d.,-]/g, '');
                                    const norm = s.includes(',') && s.includes('.')
                                      ? s.replace(/\./g, '').replace(',', '.') // 1.234,56 -> 1234.56
                                      : s.replace(',', '.');                   // 18,00 -> 18.00
                                    return parseFloat(norm);
                                  };
                                  const nota = parseNota(notaObj.total);
                                  const isHistorico = notaObj.hasHistorico === true;

                                  const notaTotal = parseNota(data.totalGrade);
                                  const notaMedia = parseNota(data.averageGrade);

                                  if (isHistorico) {
                                    notaClass = 'grade-historico';
                                  } else if (nota >= notaTotal * 0.9) {
                                    notaClass = 'grade-green';
                                  } else if (nota >= notaMedia) {
                                    notaClass = 'grade-blue';
                                  } else {
                                    notaClass = 'grade-red';
                                  }
                                }

                                return (
                                  <td key={matterData.name} className={`matter-cell ${notaClass}`}>
                                    {notaObj
                                      ? <NotaComRec nota={notaObj.total} rec={recFinal(idBimonthly, student.id, matterData.name, notaObj.total, data.averageGrade)} virgula />
                                      : '-'}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </GradesTableBody>
                    </GradesTable>
                  </div>
                ) : (
                  <GradesTable>
                    <tr><td>Sem notas de Educação Física</td></tr>
                  </GradesTable>
                )}
              </GradesTableContainer>
            </>
          )}

          {activeComponent === 'concepts' && (
            data.studentConcept && data.studentConcept.length > 0 ? (
              <>
                <ConceptsTableContainer id="printable-content-concepts">
                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}
                    <ContInfo className="info">
                      <h2>Registro de Conceitos do {renderPeriod(bimonthly)}</h2>
                      <span><strong>Escola:</strong> {data.nameSchool}</span>

                      <span><strong>Ano:</strong> {data.year}</span>
                      {data?.serie && (
                        <span><strong>Serie:</strong> {data.serie} - {data.idClass.level}</span>
                      )}
                      <span><strong>Turma:</strong> {data.nameClass}</span>
                      <span><strong>Professor(a) Regente Titular:</strong> {data.nameRegentTeacher}</span>
                      {data.nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor(a) Regente Adjunto:</strong> {data.nameRegentTeacher02}</span>
                      )}
                      {/*data.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor de Ed. Física:</strong> {data.namephysicalEducationTeacher}</span>
                      )*/}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintconcept}>Imprimir</ButtonPrint>
                  </CtnrBtt>

                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p><strong style={{ color: '#1d7f14' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                    <p><strong style={{ color: 'blue' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                    <p><strong style={{ color: 'orange' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                    <p><strong style={{ color: 'red' }}>D</strong> - Não alcançou as capacidades básicas</p>
                  </LegendBox>

                  {/* ✅ Somente a TABELA rola */}
                  <div style={{ overflowX: 'auto' }}>
                    <ConceptsTable>
                      <ConceptsTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>
                          {orderedConceptMatters(data.studentConcept).map(([matterId, matterName]) => (
                            <th key={matterId} className="matter-cell">{matterName}</th>
                          ))}
                        </tr>
                      </ConceptsTableHeader>

                      <ConceptsTableBody>
                        {Object.values(
                          data.studentConcept.reduce((acc, concept) => {
                            const studentId = concept.id_student._id;
                            if (!acc[studentId]) {
                              acc[studentId] = {
                                _id: studentId,
                                name: concept.id_student?.name || 'Sem nome',
                                concepts: {}
                              };
                            }
                            acc[studentId].concepts[concept.id_matter._id] = concept.studentGrade;
                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem conceito
                          (data.id_student || []).reduce((acc, student) => {
                            acc[student._id] = { _id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, concepts: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student._id}
                              className={`concept-row ${selectedStudentConcept === student._id ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentConcept((prev) =>
                                  prev === student._id ? null : student._id
                                )
                              }
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                              {orderedConceptMatters(data.studentConcept).map(([matterId]) => {
                                const concept = student.concepts[matterId] || '-';
                                let conceptClass = '';
                                if (concept === 'A') conceptClass = 'concept-green';
                                else if (concept === 'B') conceptClass = 'concept-blue';
                                else if (concept === 'C') conceptClass = 'concept-orange';
                                else if (concept === 'D') conceptClass = 'concept-red';

                                return (
                                  <td key={matterId} className={`matter-cell ${conceptClass}`}>
                                    {concept}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </ConceptsTableBody>
                    </ConceptsTable>
                  </div>
                </ConceptsTableContainer>
                <ConceptsTableContainer id="printable-content-concepts-physical">
                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}

                    <ContInfo className="info">
                      <h2>
                        Registro de Conceitos do {renderPeriod(bimonthly)} (Educação Física)
                      </h2>

                      <span><strong>Escola:</strong> {data.nameSchool}</span>
                      <span><strong>Ano:</strong> {data.year}</span>

                      {data?.serie && (
                        <span><strong>Série:</strong> {data.serie} - {data.idClass.level}</span>
                      )}

                      <span><strong>Turma:</strong> {data.nameClass}</span>

                      {data.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span>
                          <strong>Professor(a) de Ed. Física:</strong> {data.namephysicalEducationTeacher}
                        </span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintconceptPhysical}>
                      Imprimir
                    </ButtonPrint>
                  </CtnrBtt>

                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p><strong style={{ color: '#1d7f14' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                    <p><strong style={{ color: 'blue' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                    <p><strong style={{ color: 'orange' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                    <p><strong style={{ color: 'red' }}>D</strong> - Não alcançou as capacidades básicas</p>
                  </LegendBox>

                  {conceptsPhysical.length > 0 ? (
                    <div style={{ overflowX: 'auto' }}>
                      <ConceptsTable>
                        <ConceptsTableHeader>
                          <tr>
                            <th className="name-cell">Nome do Aluno</th>
                            <th className="matter-cell">Educação Física</th>
                          </tr>
                        </ConceptsTableHeader>

                        <ConceptsTableBody>
                          {Object.values(
                            conceptsPhysical.reduce((acc, concept) => {
                              const studentId = concept.id_student._id;

                              if (!acc[studentId]) {
                                acc[studentId] = {
                                  _id: studentId,
                                  name: concept.id_student?.name || 'Sem nome',
                                  concept: concept.studentGrade
                                };
                              }

                              return acc;
                            },
                            // começa com TODOS os alunos da turma, mesmo sem conceito
                            (data.id_student || []).reduce((acc, student) => {
                              acc[student._id] = { _id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, concept: '' };
                              return acc;
                            }, {}))
                          )
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((student) => {
                              let conceptClass = '';

                              if (student.concept === 'A') conceptClass = 'concept-green';
                              else if (student.concept === 'B') conceptClass = 'concept-blue';
                              else if (student.concept === 'C') conceptClass = 'concept-orange';
                              else if (student.concept === 'D') conceptClass = 'concept-red';

                              return (
                                <tr key={student._id}>
                                  <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                                  <td className={`matter-cell ${conceptClass}`}>
                                    {student.concept || '-'}
                                  </td>
                                </tr>
                              );
                            })}
                        </ConceptsTableBody>
                      </ConceptsTable>
                    </div>
                  ) : (
                    <ConceptsTable>
                      <tr>
                        <td>Sem conceitos de Educação Física</td>
                      </tr>
                    </ConceptsTable>
                  )}
                </ConceptsTableContainer>
              </>
            ) : (
              <ConceptsTableContainer>
                <div style={{ overflowX: 'auto' }}>
                  <ConceptsTable>
                    <tr>
                      <td>Não há conceitos registrados</td>
                    </tr>
                  </ConceptsTable>
                </div>
              </ConceptsTableContainer>
            )
          )}

          {activeComponent === 'individualRecords' && (
            <IndividualContainerDivs id='print-area' >
              <IndividualPrintStyle />
              <CtnrBtt>
                <ButtonPrint className="no-print" onClick={handlePrintIndividualForm}>Imprimir</ButtonPrint>
              </CtnrBtt>
              <IndividualStudentSection id="printable-content-individualRecords">
                <ContLogo className="cont-logo-individualForm">
                  {(logoUrl) && (
                    <Preview className="logo-individualForm" src={logoUrl} alt="Logo da escola" />
                  )}
                  <h2 className="h2indForm">Relatórios Individuais de Alunos</h2>
                </ContLogo>
                <h3>{renderPeriod(bimonthly)}</h3>
                <span><strong>Escola:</strong> {data.nameSchool}</span>

                <span><strong>Ano:</strong> {data.year}</span>
                {data?.serie && (
                  <span><strong>Serie:</strong> {data.serie} - {data.idClass.level}</span>
                )}
                <span><strong>Turma:</strong> {data.nameClass}</span>

                {Array.isArray(data.id_individualForm) && data.id_individualForm.length > 0 ? (
                  data.id_individualForm
                    .sort((a, b) => a.id_student.name.localeCompare(b.id_student.name))
                    .map((res, index) => (
                      <IndividualContainerTable key={res._id}>
                        <Span>
                          {Array.isArray(data.idRegentTeacher) && data.idRegentTeacher.includes(res.id_teacher._id) ? (
                            <>
                              <div>Professor(a) Regente Titular: <p>{res.id_teacher.name}</p></div>
                              {data.nameRegentTeacher02 &&
                                data.nameRegentTeacher02 !== "Professor não definido" && (
                                  <div>Professor(a) Regente Adjunto: <p>{data.nameRegentTeacher02}</p></div>
                                )}
                            </>
                          ) : Array.isArray(data.idRegentTeacher02) && data.idRegentTeacher02.includes(res.id_teacher._id) ? (
                            <>
                              {/* Se quem lançou é o Professor 02, mostra os dois */}
                              {data.nameRegentTeacher && data.nameRegentTeacher !== "Professor não definido" && (
                                <div>Professor(a) Regente Titular: <p>{data.nameRegentTeacher}</p></div>
                              )}
                              <div>Professor(a) Regente Adjunto: <p>{res.id_teacher.name}</p></div>
                            </>
                          ) : Array.isArray(data.idPhysicalEducationTeacher) && data.idPhysicalEducationTeacher.includes(res.id_teacher._id) ? (
                            <div>Professor(a) de Ed. Física: <p>{res.id_teacher.name}</p></div>
                          ) : null}


                          <div>Aluno(a): <p>{res.id_student.name}</p></div>
                        </Span>

                        <IndividualTableRow>
                          <IndividualDescriptionCell>
                            <div className={`description ${expandedRows.includes(index) ? 'expanded' : 'collapsed'}`}>
                              <div
                                style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{
                                  __html: expandedRows.includes(index) || printing
                                    ? res.description
                                    : getDescriptionPreview(res.description),
                                }}
                              />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              {!printing && (
                                <Button onClick={() => toggleRowExpansion(index)} className="no-print">
                                  {expandedRows.includes(index) ? 'Ver Menos' : 'Ver Mais'}
                                </Button>
                              )}
                              {expandedRows.includes(index) && positionAtSchool === 'DIRETOR/SUPERVISOR' && (
                                <Button onClick={() => handleEdit(index, res)} className="no-print">
                                  Editar
                                </Button>
                              )}
                            </div>
                          </IndividualDescriptionCell>
                        </IndividualTableRow>

                        {editingIndex === index && (
                          <EditContainer>
                            <div className="modal-content">
                              <h3>Editando Ficha</h3>
                              <ReactQuill
                                theme="snow"
                                modules={{
                                  toolbar: [
                                    [{ 'font': [] }],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['bold', 'italic', 'underline'],
                                    [{ 'color': [] }, { 'background': [] }],
                                    ['clean']
                                  ]
                                }}
                                value={editedDescription}
                                onChange={(e) => setEditedDescription(e)}
                                placeholder="Descrição da aula"
                                style={{
                                  height: 'auto', // aumentado de 250px para 350px
                                  maxHeight: '550px',
                                  overflow: 'auto',
                                  zIndex: 0,
                                  position: 'relative'
                                }}
                              />
                              {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                              <div style={{ position: 'relative', zIndex: 10, marginTop: '30px', }} className='BoxBtt'>
                                <ButtonEdit onClick={handleSaveEditIndForm}>Salvar</ButtonEdit>
                                <ButtonEdit onClick={() => setEditingIndex(null)}>Cancelar</ButtonEdit>
                              </div>
                            </div>
                          </EditContainer>
                        )}
                      </IndividualContainerTable>
                    ))
                ) : (
                  <InfoText>Não há nenhum registro</InfoText>
                )}
              </IndividualStudentSection>
            </IndividualContainerDivs>
          )}

          {activeComponent === 'finalConcepts' && (
            data.id_FinalConcepts && data.id_FinalConcepts.length > 0 ? (
              <>
                <ConceptsTableContainer id="printable-content-concepts">
                  <HeaderWrapper className="HeaderWrapper">
                    {(logoUrl) && (
                      <Preview className="logo-print" src={logoUrl} alt="Logo da escola" />
                    )}
                    <ContInfo className="info">
                      <span><strong>Escola:</strong> {data.nameSchool}</span>

                      <span><strong>Ano:</strong> {data.year}</span>
                      {data?.serie && (
                        <span><strong>Serie:</strong> {data.serie}</span>
                      )}
                      <span><strong>Turma:</strong> {data.nameClass}</span>
                      <span><strong>Professor Regente Titular:</strong> {data.nameRegentTeacher}</span>
                      {data.nameRegentTeacher02 !== "Professor não definido" && (
                        <span><strong>Professor Regente Adjunto:</strong> {data.nameRegentTeacher02}</span>
                      )}
                      {data.namephysicalEducationTeacher !== "Professor não definido" && (
                        <span><strong>Professor de Ed. Física:</strong> {data.namephysicalEducationTeacher}</span>
                      )}
                    </ContInfo>
                  </HeaderWrapper>

                  <CtnrBtt>
                    <ButtonPrint className="no-print" onClick={handlePrintconcept}>Imprimir</ButtonPrint>
                  </CtnrBtt>

                  <LegendBox className="legendBox">
                    <h3>Legenda</h3>
                    <p><strong style={{ color: '#1d7f14' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                    <p><strong style={{ color: 'blue' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                    <p><strong style={{ color: 'orange' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                    <p><strong style={{ color: 'red' }}>D</strong> - Não alcançou as capacidades básicas</p>
                  </LegendBox>

                  {/* ✅ Somente a TABELA rola */}
                  <div style={{ overflowX: 'auto' }}>
                    <ConceptsTable>
                      <ConceptsTableHeader>
                        <tr>
                          <th className="name-cell">Nome do Aluno</th>
                          {orderedConceptMatters(data.studentConcept).map(([matterId, matterName]) => (
                            <th key={matterId} className="matter-cell">{matterName}</th>
                          ))}
                        </tr>
                      </ConceptsTableHeader>

                      <ConceptsTableBody>
                        {Object.values(
                          data.id_FinalConcepts.reduce((acc, concept) => {
                            const studentId = concept.id_student._id;
                            if (!acc[studentId]) {
                              acc[studentId] = {
                                _id: studentId,
                                name: concept.id_student?.name || 'Sem nome',
                                concepts: {}
                              };
                            }
                            acc[studentId].concepts[concept.id_matter._id] = concept.studentGrade;
                            return acc;
                          },
                          // começa com TODOS os alunos da turma, mesmo sem conceito
                          (data.id_student || []).reduce((acc, student) => {
                            acc[student._id] = { _id: student._id, name: student.name, cpf: student.cpf, dateOfBirth: student.dateOfBirth, concepts: {} };
                            return acc;
                          }, {}))
                        )
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((student) => (
                            <tr
                              key={student._id}
                              className={`concept-row ${selectedStudentConcept === student._id ? 'selected' : ''}`}
                              onClick={() =>
                                setSelectedStudentConcept((prev) =>
                                  prev === student._id ? null : student._id
                                )
                              }
                            >
                              <td className="name-cell">{student.name}<BirthDate cpf={student.cpf} dob={student.dateOfBirth} /></td>
                              {orderedConceptMatters(data.studentConcept).map(([matterId]) => {
                                const concept = student.concepts[matterId] || '-';
                                let conceptClass = '';
                                if (concept === 'A') conceptClass = 'concept-green';
                                else if (concept === 'B') conceptClass = 'concept-blue';
                                else if (concept === 'C') conceptClass = 'concept-orange';
                                else if (concept === 'D') conceptClass = 'concept-red';

                                return (
                                  <td key={matterId} className={`matter-cell ${conceptClass}`}>
                                    {concept}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                      </ConceptsTableBody>
                    </ConceptsTable>
                  </div>
                </ConceptsTableContainer>
              </>
            ) : (
              <ConceptsTableContainer>
                <div style={{ overflowX: 'auto' }}>
                  <ConceptsTable>
                    <tr>
                      <td>Não há conceitos registrados</td>
                    </tr>
                  </ConceptsTable>
                </div>
              </ConceptsTableContainer>
            )
          )}

          <ToGoBack onClick={() => window.history.back()} className="no-print">
            <SignMessageButtonText>Voltar para a</SignMessageButtonText>
            <SignMessageButtonTextBold>Página Anterior</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      }

    </Container >
  );
}